export default __webpack_public_path__ + "static/media/login.90cc66f3.svg";